// gimme: conversations-inbox-ui 05/26/2020 741c62dc71ca742adbc6d64d61d30de7cb46539f
'use es6';

import { createSelector } from 'reselect';
import { getFocusedThreadDetails } from './getFocusedThreadDetails';
import { getInboxId } from 'conversations-thread-data/thread-details/public/operators';
export const getCurrentThreadInboxId = createSelector([getFocusedThreadDetails], getInboxId);